import Cookies from 'js-cookie';

const GOOGLE_CLICK_ID = 'gclid',
 ALLOWED_SUBDOMAINS = [
	'www.',
	'fast.'
];

/**
 * Service for handling Google Click ID tracking for conversion attribution : SCP-3112
 */
class GoogleClickTrackingService {
	init() {
		this.#initGoogleClickTracking();
	}
	
	/**
	 * @private
	 */
	#initGoogleClickTracking() {
		const currentGoogleClickId = this.#extractGoogleClickIdFromUrl();
		
		if (currentGoogleClickId) {
			this.#storeGoogleClickId(currentGoogleClickId);
		}
	}
	
	/**
	 * @returns {string|null}
	 * @private
	 */
	#extractGoogleClickIdFromUrl() {
		const urlParams = new URLSearchParams(window.location.search);

		return urlParams.get(GOOGLE_CLICK_ID);
	}
	
	/**
	 * @param {string} googleClickId
	 * @private
	 */
    #storeGoogleClickId(googleClickId) {
        const {hostname} = location,

         matchedSubdomain = ALLOWED_SUBDOMAINS.find((sub) => hostname.startsWith(sub)),
         rootDomain = matchedSubdomain ? hostname.slice(matchedSubdomain.length) : hostname;

        Cookies.set(GOOGLE_CLICK_ID, googleClickId, {
            'path'    : '/',
            'domain'  : `.${rootDomain}`,
            'sameSite': 'Lax'
        });
    }
}

export default new GoogleClickTrackingService();